module.exports = __webpack_public_path__ + "img/jiance.702069f3.png";